import { render, staticRenderFns } from "./PrintPosFacturaTicket.vue?vue&type=template&id=50760673&scoped=true"
import script from "./PrintPosFacturaTicket.vue?vue&type=script&lang=js"
export * from "./PrintPosFacturaTicket.vue?vue&type=script&lang=js"
import style0 from "./PrintPosFacturaTicket.vue?vue&type=style&index=0&id=50760673&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50760673",
  null
  
)

export default component.exports